import React from "react";

const StatusPill = ({ variant, status, widthClass }) => {
  const pillVariantClass = {
    success: "bg-[#ECFDF3] text-[#067647] border-[#ABEFC6]",
    error: "bg-[#FEF3F2] text-[#B42318] border-[#FECDCA]",
  };

  return (
    <div
      className={`text-inter text-14 font-medium flex items-center justify-center rounded-full border px-8 py-2 ${pillVariantClass[variant]} ${widthClass}`}
    >
      {status}
    </div>
  );
};

export default StatusPill;
